import Plane from "../_app/cuchillo/3D/Plane";
import Text3D from "../_app/cuchillo/3D/Text3D";
import { GetBy } from "../_app/cuchillo/core/Element";
import Box from "./Box";

export default class BoxManifesto extends Box {
  constructor(__dom) {
    super(__dom);

    const text = GetBy.selector('[data-text]', __dom)[0];
    const text3D = new Text3D({ dom: text, text: text.dataset.text });
    this.add(text3D);
    this.items.push(text3D);

    const textIndex = GetBy.selector('[data-text-index]', __dom)[0];
    const textIndex3D = new Text3D({ dom: textIndex, text: textIndex.dataset.textIndex });
    this.add(textIndex3D);
    this.items.push(textIndex3D);

    // const plane = GetBy.selector('[data-bg]', __dom)[0];
    // const plane3D = new Plane({
    //   dom: plane,
    //   size: {
    //     y: parseInt(plane.dataset.height),
    //     x: parseInt(plane.dataset.width)
    //   }
    // });
    // this.add(plane3D);
    // this.items.push(plane3D);
  }
}
